import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api-client.js';

const MAX_RETRIES = 2;
const STALE_TIME_MS = 30_000;

const shouldRetry = (failureCount: number, error: Error): boolean => {
  const isClientError = error instanceof ApiError && error.status >= 400 && error.status < 500;

  return !isClientError && failureCount < MAX_RETRIES;
};

export const createQueryClient = (): QueryClient =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: STALE_TIME_MS,
        refetchOnWindowFocus: false,
        retry: shouldRetry,
      },
      mutations: { retry: false },
    },
  });
